import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const TermsOfService = () => {
    console.log(`[${new Date().toISOString()}] TermsOfService component render`);
    const { t } = useTranslation();

    // Colors for consistent theming
    const primaryTextColor = "text-silver-light"; // Very light gray/silver
    const secondaryTextColor = "text-silver-medium"; // Medium gray/silver

    return (
        <div className="bg-black min-h-screen pt-24 pb-16">
            <SEO
                title="Terms of Service | Riviera Tech Solutions"
                description="Read the Terms of Service for Riviera Tech Solutions, including service usage rules, user responsibilities, and legal conditions."
                keywords="terms of service, website terms, legal terms Riviera Tech, service conditions"
                url="/terms"
            />
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">
                    <h1 className={`text-4xl font-serif font-medium mb-6 ${primaryTextColor}`}>{t('legal.termsOfService.title')}</h1>
                    <p className={`${secondaryTextColor} mb-8`}>{t('legal.lastUpdated')}: {new Date().toLocaleDateString()}</p>

                    <div className="space-y-8">
                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section1.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section1.paragraph1')}</p>
                                <p>{t('legal.termsOfService.section1.paragraph2')}</p>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section2.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section2.paragraph1')}</p>
                                <p>{t('legal.termsOfService.section2.paragraph2')}</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>{t('legal.termsOfService.section2.restrictions.item1')}</li>
                                    <li>{t('legal.termsOfService.section2.restrictions.item2')}</li>
                                    <li>{t('legal.termsOfService.section2.restrictions.item3')}</li>
                                    <li>{t('legal.termsOfService.section2.restrictions.item4')}</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section3.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section3.paragraph1')}</p>
                                <p>{t('legal.termsOfService.section3.paragraph2')}</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>{t('legal.termsOfService.section3.exceptions.item1')}</li>
                                    <li>{t('legal.termsOfService.section3.exceptions.item2')}</li>
                                    <li>{t('legal.termsOfService.section3.exceptions.item3')}</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section4.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section4.paragraph1')}</p>
                                <p>{t('legal.termsOfService.section4.paragraph2')}</p>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section5.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section5.paragraph1')}</p>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section6.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section6.paragraph1')}</p>
                                <p>{t('legal.termsOfService.section6.paragraph2')}</p>
                            </div>
                        </section>

                        <section>
                            <h2 className={`text-2xl font-medium mb-4 ${primaryTextColor}`}>{t('legal.termsOfService.section7.heading')}</h2>
                            <div className={`${secondaryTextColor} space-y-4 text-sm leading-relaxed`}>
                                <p>{t('legal.termsOfService.section7.paragraph1', { email: 'support@rivieratech.solutions' })}</p>
                            </div>
                        </section>
                    </div>

                    <div className="mt-10 pt-6 border-t border-gray-800">
                        <p className="text-[11px] uppercase tracking-[0.16em] text-silver-dark mb-2">Related pages</p>
                        <p className="text-xs sm:text-sm text-silver-medium">
                            <Link to="/privacy" className="text-silver-dark hover:text-silver-medium transition-colors">Privacy Policy</Link>
                            {" · "}
                            <Link to="/cookies" className="text-silver-dark hover:text-silver-medium transition-colors">Cookie Policy</Link>
                            {" · "}
                            <Link to="/eula" className="text-silver-dark hover:text-silver-medium transition-colors">EULA</Link>
                            {" · "}
                            <Link to="/contact" className="text-silver-dark hover:text-silver-medium transition-colors">Contact</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
